<!-- <div class="action-panel">
    <div *ngFor='let btn of btnArray'>
      <itb-default-button [iconClassName]="btn.iconClassName" [isHidden]="btn.isHidden" [isDisabled]="btn.isDisabled" [className]="btn.className" [isLoading]="btn.isLoading" [text]="btn.text" (onClickHandler)=clickEvent(btn.buttonName)></itb-default-button>
    </div>
</div> -->
<div class="action-panel simple-action-panel" (window:resize)="doAdapt()">
  <nav class="tabs adaptive-buttons">
    <ul class="-primary">
      <itb-default-button *ngFor='let btn of btnArray' [iconClassName]="btn.iconClassName" [isHidden]="btn.isHidden" [isDisabled]="btn.isDisabled" [className]="btn.className" [isLoading]="btn.isLoading" [text]="btn.text" (onClickHandler)=clickEvent(btn.buttonName)></itb-default-button>
    </ul>
  </nav>
</div>